// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'
// Component Imports
// JS Imports
// Asset Imports

export default function BundleDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const { getString } = state

   if (
      state.user_role != 'Partner' &&
      state.user_role != 'Reseller' &&
      (state.user_view == 'Internal' || state.hasUSEmployees == true)
   )
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1'>
               <DiscountDescriptionBox
                  discountDescription={
                     state.discount_list['bundleDiscount'][
                        'DiscountDescription'
                     ]
                  }
                  discountName={
                     state.discount_list['bundleDiscount']['DiscountName']
                  }
                  hoverTitle={getString(
                     'product.BundleDiscountRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>

            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.discountBundle}
                  onChange={() => state.setDiscountBundle((prev) => !prev)}
               ></input>
            </div>
            <div className='col'>
               {state.discount_list['bundleDiscount']['DiscountAmount']}%
            </div>
         </div>
      )
}
